// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"VideoLoading_loadingWrapper__-AuJR","lottieLoader":"VideoLoading_lottieLoader__mA2Kj","loadingText":"VideoLoading_loadingText__0Xa4z"};